import { render, staticRenderFns } from "./Outbound.vue?vue&type=template&id=3db06fd3&scoped=true&"
import script from "./Outbound.vue?vue&type=script&lang=js&"
export * from "./Outbound.vue?vue&type=script&lang=js&"
import style0 from "./Outbound.vue?vue&type=style&index=0&id=3db06fd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db06fd3",
  null
  
)

export default component.exports